module.exports = __webpack_public_path__ + "img/cart.4d8725c9.png";